import { RentaTarifa } from "src/gql/schema"

export type RentaTarifaAgrupada = {
    tarifa_id: string
    tarifa: RentaTarifa["tarifa"]
    total: number
    entradas: {
        fecha_inicio: string
        fecha_fin: string
        subtotales: RentaTarifa["subtotales"]
    }[]
}

export function groupRentasTarifasByTarifa(
    rentas_tarifas: RentaTarifa[]
): RentaTarifaAgrupada[] {
    const map = rentas_tarifas.reduce<Record<string, RentaTarifaAgrupada>>((acc, item) => {
        if (!acc[item.tarifa_id]) {
            acc[item.tarifa_id] = {
                tarifa_id: item.tarifa_id,
                tarifa: item.tarifa,
                total: 0,
                entradas: [],
            }
        }
        acc[item.tarifa_id].entradas.push({
            fecha_inicio: item.fecha_inicio,
            fecha_fin: item.fecha_fin,
            subtotales: item.subtotales,
        })
        acc[item.tarifa_id].total += item.subtotales?.total ?? 0
        return acc
    }, {})

    return Object.values(map)
}
